import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import LoginHeader from './login.header';
import Arrow from '../../../components/common/arrow';
import { PALETTE, EBANKINGWEBLUX, EBANKINGWEBUK, EBANKINGWEB, KEY_CODE } from '../../../constants';
import envConfig from '../../../../db-env-build';

class LoginContactUs extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { languages: { destLanguageCode }, auth: { setInvalidLogin} } = this.props;
        setInvalidLogin(false);
        if(document.querySelector('.contactUsFocus')){
            document.querySelector('.contactUsFocus').focus();
        }
    }

    onBackClick = (e) => {
        if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){   
            this.props.changePage('/login');
        }
    }

    render = () => {

        const { i18n: { messages }, ui: { history: { goBack } } } = this.props;

        return (
            <View>
                <View className="login-container margin-bottom-30">
                    <LoginHeader />
                </View >
                <View className="faq-container">
                    <div className='display-flex-row'>
                        <div className='small-3 display-flex-row faq-title-container'>
                            <div tabIndex={0} className="cursor-pointer" onKeyDown={(e) => this.onBackClick(e)} onClick={() => this.onBackClick()} aria-label={messages['app.documentUpload.button.back']} role="button">
                                <Arrow
                                    direction="left"
                                    width={7}
                                    height={10}
                                    color={PALETTE.secondaryActive}
                                    thickness={2}
                                    id="arrow_backLink_test"
                                /></div>
                            <div tabIndex={0} className="font-size-34 padding-left-20 font-db-display contactUsFocus" testID="text_loginTitle_userLogin_test" >{messages['app.login.contact.us']}</div>
                        </div>
                    </div>
                    <div className='display-flex-row margin-top-30'>
                        <div className='small-6 bg-dawn-blue padding-25 margin-left-20 font-size-16'>
                            <div tabIndex={0}>{envConfig.envConfig === EBANKINGWEB ? messages["app.login.contact.us.content"] : messages["app.login.contact.us.desc1"] }</div><br/>
                            <div tabIndex={0}>{envConfig.envConfig !== EBANKINGWEB && messages["app.login.contact.us.desc2"]}</div><br/>
                            <div tabIndex={0}>{envConfig.envConfig !== EBANKINGWEB && messages["app.login.contact.us.desc3"]}
                            {envConfig.envConfig === EBANKINGWEBLUX && <a href="mailto:dwo-lux.helpdesk@db.com"> {messages['app.security.tips.lux.helpdesk']}</a>}
                            {envConfig.envConfig === EBANKINGWEBUK && <a href="mailto:dwouk.helpdesk@db.com"> {messages['app.security.tips.uk.helpdesk']}</a>}   
                             </div>         
                        </div>
                    </div>
                </View >
            </View>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        ui: {
            history: {
                goBack: { $call: 'goBack' },
            }
        },
        auth: {
            setInvalidLogin: { $set: 'invalidLogin'}
        }
    },
})(LoginContactUs);


